import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijf", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Medewerker", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Deadline", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Selecteer een collega", -1)

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { issueStore } from '@/stores/issue'
import { authStore } from '@/stores/auth'
import { closedIssueStates } from '@/helpers/issueStates'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { WarningTwoTone } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowAssignedToCard',
  setup(__props) {

const router = useRouter()
const showForwardModal = ref(false)
const solvers = ref([])
const newSolverId = ref<number|null>(null)

onMounted(() => {
  getSolvers()
})

function getSolvers () : void {
  axios.get(process.env.VUE_APP_API_URL + '/companies/' + authStore().user.company_id + '/solvers').then((r) => {
    solvers.value = r.data.data
  })
}

function toggleForwardModal () : void {
  showForwardModal.value = !showForwardModal.value

  if (!showForwardModal.value) {
    newSolverId.value = null
  }
}

function redirectIssue () : void {
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + issueStore().issue.id + '/forward', { solver_id: newSolverId.value }).then(() => {
    toggleForwardModal()
    router.push({ name: 'Issues' })
    notification.success({
      message: 'Servicemelding doorverwezen.',
      description: 'De servicemelding is succesvol doorverwezen naar uw collega.',
      duration: 5
    })
  })
}

function filterItems (input:string, item:{ key:string, value:number }) {
  return item.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

function checkIfOverdue (issue:{ estimate:string|null, status:number }) : boolean {
  return issue.estimate !== null && new Date(issue.estimate).getTime() < new Date().getTime() && !closedIssueStates.includes(issue.status)
}

function checkIfAlmostOverdue (issue:{ estimate:string|null, status:number }) : boolean {
  if (!issue.estimate) {
    return false
  }

  const TenDaysBeforeEstimate = new Date(issue.estimate)
  TenDaysBeforeEstimate.setDate(TenDaysBeforeEstimate.getDate() - 10)
  return issue.estimate !== null && new Date().getTime() >= TenDaysBeforeEstimate.getTime() && !closedIssueStates.includes(issue.status)
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Toegewezen aan",
    bordered: false
  }, {
    extra: _withCtx(() => [
      (solvers.value.length > 1 && !_unref(closedIssueStates).includes(_unref(issueStore)().issue.status))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            onClick: toggleForwardModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("Doorverwijzen")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_unref(issueStore)().issue.solver_company)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.solver_company.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.solver)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.solver.full_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, { class: "no-mb" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 9 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            offset: 1,
            span: 14
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_unref(issueStore)().issue.estimate ? new Date(_unref(issueStore)().issue.estimate).toLocaleDateString('nl-NL') : '-') + " ", 1),
                (checkIfOverdue(_unref(issueStore)().issue))
                  ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                      key: 0,
                      "two-tone-color": "red",
                      style: {"margin-left":"8px"}
                    }))
                  : (checkIfAlmostOverdue(_unref(issueStore)().issue))
                    ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                        key: 1,
                        "two-tone-color": "#f38929",
                        style: {"margin-left":"8px"}
                      }))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        title: "Selecteer een collega",
        visible: showForwardModal.value,
        onCancel: toggleForwardModal
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            key: "back",
            onClick: toggleForwardModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annuleren")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: redirectIssue
          }, {
            default: _withCtx(() => [
              _createTextVNode("Doorverwijzen")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_a_select, {
                    "filter-option": filterItems,
                    value: newSolverId.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((newSolverId).value = $event)),
                    "show-search": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solvers.value, (s) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: s.id,
                          key: s.name,
                          disabled: s.id === _unref(authStore)().user.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(s.full_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}
}

})